const mobileMenu = document.querySelector('.mobile-navigation')
const mobileMenuToggleButton = document.querySelectorAll('[data-mobile-menu-toggle]')

let isMobileMenuExpanded = false

function openMenu() {
    isMobileMenuExpanded = true
    document.body.classList.add('no-scroll')
    mobileMenu.classList.add('active')
    mobileMenu.removeAttribute('inert')
    mobileMenu.removeAttribute('hidden')
    mobileMenuToggleButton.forEach((element) => {
        element.setAttribute('aria-expanded', 'true')
    })
    if (mobileMenuToggleButton.length > 0) {
        mobileMenuToggleButton[0].focus()
    }
}

export function closeMenu() {
    isMobileMenuExpanded = false
    document.body.classList.remove('no-scroll')
    mobileMenu.classList.remove('active')
    mobileMenu.setAttribute('inert', '')
    mobileMenu.setAttribute('hidden', '')
    mobileMenuToggleButton.forEach((element) => {
        element.setAttribute('aria-expanded', 'false')
    })
}

export function toggleMenu() {
    isMobileMenuExpanded ? closeMenu() : openMenu()
}

mobileMenuToggleButton.forEach((element) =>
    element.addEventListener('click', toggleMenu)
)

mobileMenu.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') toggleMenu()
})